const DEFAULT_INVITE_DETAILS = {
  title: "Event Title",
  host: "Your Name",
  description: "Event Description",
  eventDate: new Date(),
  location: "123 Location Ave Los Angeles, CA 90012",
};

Object.freeze(DEFAULT_INVITE_DETAILS);

export { DEFAULT_INVITE_DETAILS };
